import styled from "styled-components";
import Footer from "../components/Footer";
import AboutUsPhoto from "../assets/aboutus.jpg";
const AboutUsPage = () => {
  return (
    <>
      <Wrapper>
        <div className="image-container">
          <img
            src={AboutUsPhoto}
            alt="backgroundPhoto"
            className="aboutImage"
          />
        </div>
        <div className="about-us-container">
          <p>
            ABG test se sastoji od centralnog laboratorija smještenog u
            Divaltovoj 195 Osijek i terenskog laboratorija za ispitivanje
            asfalta i bitumenskog veziva koji se nalazi u Našicama.
          </p>
          <p>
            Djelatnici ABG test-a su obučeni i stručni, a ispitivanja provode
            umjerenom opremom. ABG test d.o.o akreditirani je ispitni
            laboratorij prema normi HRN EN ISO/IEC 17025:2017 od strane Hrvatske
            akreditacijske agencije u području opisanom u{" "}
            <a
              className="acreditation-link"
              href="https://drive.google.com/uc?export=download&id=1v_J1PtU63iUn_7nYD9faF1UohAmqDkrs"
            >
              prilogu potvrde o akreditaciji br. 1631.
            </a>{" "}
          </p>
        </div>
      </Wrapper>
      <Footer />
    </>
  );
};

const Wrapper = styled.div`
  .acreditation-link {
    color: white;
    /* text-decoration: none; */
    color: white;
    font-family: "bold";
    transition-duration: 0.5s;
  }
  .acreditation-link:hover {
    color: blue;
  }
  .about-us-container {
    position: relative;
    /* height: 60vh; */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(375px, 1fr));
    color: white;
    p {
      text-align: left;
      line-height: 3rem;
      font-size: 1.4rem;
      margin: 6.5rem 6.5rem;
    }
  }
  .image-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    img {
      min-width: 100vw;
      object-fit: cover;
    }
  }
  @media only screen and (max-width: 870px) {
    .about-us-container {
      p {
        margin: 4rem 2rem;
      }
    }
  }
`;

export default AboutUsPage;
